import {dateWithTime} from "@/utilities/dateTimeUtils";

export default {
    SET_NEW_TOURS: (state, tours) => {
        state.tours = tours
    },
    SET_USERS: (state, users) => {
        state.users = users
    },
    SET_POSTS: (state, posts) => {
      state.posts = posts
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_OPERATIONS: (state, operations) => {
        state.operations = operations
    },
    SET_ADDITIONAL_PROPS: (state, props) => {
      state.additionalProps =  props
    },
    SET_REPORTS: (state, reports) => {
        state.reports = reports
    },
    SET_FINISHED_TESTS: (state, finishedTests) => {
        finishedTests.map(el => {
            el.name = `${el.name}, завершен ${dateWithTime(el.finished_at)}, ${el.respondent_full_name}`
        })
        state.finishedTests = finishedTests
    },
    SET_NOT_FINISHED_TESTS: (state, notFinishedTests) => {
        notFinishedTests.map(el => {
            el.name = `${el.name}, от ${dateWithTime(el.createdAt)}, ${el.respondent_full_name}`
        })
        state.notFinishedTests = notFinishedTests
    },
    SET_GROUPS: (state, groups) => {
        state.groups = groups
    },
    SET_THEMES: (state, themes) => {
        state.themes = themes
    }
}